<template>
  <div>
    <mu-dialog
      title="抵扣详情"
      width="500"
      :open="open"
      @close="close"
      class="details-dialog"
    >
      <mu-data-table :columns="columns" :data="list" stripe class="table">
        <template slot-scope="scope">
          <td>{{ scope.row.order.orderId }}</td>
          <td>{{ scope.row.order.sum }}</td>
          <td>{{ scope.row.money }}</td>
        </template>
      </mu-data-table>
      <mu-button slot="actions" color="primary" @click="revoke">撤销</mu-button>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >关闭</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
// import backend from 'utils/backend'
// import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    list: {
      type: Array
    }
  },
  data() {
    return {
      columns: [
        {
          title: '订单',
          name: 'order',
          align: 'center'
        },
        {
          title: '订单金额',
          name: 'sum',
          align: 'center'
        },
        {
          title: '抵扣金额',
          name: 'money',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    revoke() {},
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.details-dialog {
  .table {
    th,
    td {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payment/details.vue